import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../../../utils/apiHelper";
import { toast } from "react-toastify";

export const fetchProcessDetails = createAsyncThunk(
    "process/fetchProcessDetails",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}/process-details`);
            if (response.data.code === "00000") {
                console.log("Process Details Response:", response.data);  // Debug için log ekleyelim
                return response.data.startupProcessDetails;
            }
            throw new Error("Failed to fetch process details");
        } catch (error) {
            toast.error('Süreç detayları yüklenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

export const updateProcess = createAsyncThunk(
    "process/updateProcess",
    async (processData, { rejectWithValue, dispatch }) => {
        try {
            const response = await ApiHelper.put("/startup/process-details", processData);
            if (response.data.code === "00000") {
                toast.success("Süreç detayları başarıyla güncellendi");
                await dispatch(fetchProcessDetails(processData.startupId));
                return processData;
            }
            throw new Error("Process update failed");
        } catch (error) {
            toast.error("Süreç detayları güncellenirken bir hata oluştu");
            return rejectWithValue(error.message);
        }
    }
);

const processSlice = createSlice({
    name: "process",
    initialState: {
        processDetails: null,
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProcessDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProcessDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.processDetails = action.payload;
                state.error = null;
            })
            .addCase(fetchProcessDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateProcess.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateProcess.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(updateProcess.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default processSlice.reducer;
